module.exports = __webpack_public_path__ + "static/img/m_home_advantage_easy@3x.a663386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_home_advantage_easy@3x.png
// module id = w5Dj
// module chunks = 1